import { View, Text, TouchableOpacity, ScrollView, Modal, StyleSheet } from 'react-native'
import Ionicons from '@expo/vector-icons/Ionicons'
import { useThemeColors } from '../../lib/useThemeColors'
import { fonts } from '../../lib/theme'
import { useTranslation } from 'react-i18next'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

export default function Sheet({ visible, title, onClose, children, footer }) {
  const tc = useThemeColors()
  const { t } = useTranslation()
  const insets = useSafeAreaInsets()

  return (
    <Modal visible={visible} transparent animationType="slide" onRequestClose={onClose}>
      <View style={styles.wrapper}>
        <TouchableOpacity style={styles.overlay} activeOpacity={1} onPress={onClose} accessible={false} />
        <View style={[styles.sheet, { backgroundColor: tc.bgCard, borderColor: tc.border }]}>
          <View style={[styles.sheetHeader, { borderBottomColor: tc.border }]}>
            <Text style={[styles.sheetTitle, { color: tc.text }]} accessibilityRole="header">{title}</Text>
            <TouchableOpacity
              style={[styles.closeBtn, { backgroundColor: tc.bgCard2, borderColor: tc.border }]}
              onPress={onClose}
              accessibilityRole="button"
              accessibilityLabel={t('pick.close')}
              hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}
            >
              <Ionicons name="close" size={16} color={tc.textMuted} />
            </TouchableOpacity>
          </View>
          <ScrollView contentContainerStyle={{ padding: 16 , paddingBottom: 16 + insets.bottom }} keyboardShouldPersistTaps="handled">
            {children}
          </ScrollView>
          {footer && (
            <View style={[styles.sheetFooter, { borderTopColor: tc.border , paddingBottom: insets.bottom + 16 }]}>{footer}</View>
          )}
        </View>
      </View>
    </Modal>
  )
}

const styles = StyleSheet.create({
  wrapper: { flex: 1, justifyContent: 'flex-end' },
  overlay: { ...StyleSheet.absoluteFillObject, backgroundColor: 'rgba(0,0,0,0.6)' },
  sheet: { borderTopLeftRadius: 20, borderTopRightRadius: 20, borderWidth: 1, minHeight: '45%', maxHeight: '90%' },
  sheetHeader: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: 16, borderBottomWidth: 1 },
  sheetTitle: { fontFamily: fonts.condensedBold, fontSize: 16, textTransform: 'uppercase' },
  closeBtn: { borderWidth: 1, borderRadius: 8, width: 44, height: 44, alignItems: 'center', justifyContent: 'center' },
  closeBtnText: { fontSize: 14 },
  sheetFooter: { padding: 16, borderTopWidth: 1 },
})